var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "map",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "themeSVGStroke themeSVGStrokeHover",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "art"
  }, /*#__PURE__*/React.createElement("line", {
    className: "themeable",
    id: "Line_14446",
    "data-name": "Line 14446",
    x1: 5,
    y1: 29.5,
    x2: 27,
    y2: 29.5,
    fill: "none",
    stroke: "#3c4347",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8801",
    "data-name": "Group 8801"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "themeable",
    id: "Ellipse_88",
    "data-name": "Ellipse 88",
    cx: 16,
    cy: 9.5,
    r: 4,
    fill: "none",
    stroke: "#3c4347",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8800",
    "data-name": "Group 8800"
  }, /*#__PURE__*/React.createElement("path", {
    className: "themeable",
    id: "Path_10582",
    "data-name": "Path 10582",
    d: "M16,25.5s5.17-6.46,6.4-8.19A12.81,12.81,0,0,0,25,10.5a9,9,0,0,0-18,0,12.86,12.86,0,0,0,2.6,6.8C10.83,19,16,25.5,16,25.5Z",
    fill: "none",
    stroke: "#3c4347",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    vectorEffect: "non-scaling-stroke"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "square"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1687",
    "data-name": "Rectangle 1687",
    width: 32,
    height: 32,
    style: {
      fill: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.70f93bd34193b9c1729e4a38109d0df6.svg";
export { ForwardRef as ReactComponent };